var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_829_2520)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 20.0001,
    r: 15.381,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_2520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9406 11.9385C17.4835 11.9385 15.4792 13.9497 15.4792 16.4067C15.4792 17.9087 16.2308 19.2394 17.3745 20.0489C14.7068 21.1178 12.8142 23.7263 12.8142 26.7698C12.8183 26.9537 12.8942 27.1287 13.0257 27.2574C13.1573 27.386 13.3339 27.4581 13.5179 27.4581C13.7019 27.4581 13.8786 27.386 14.0101 27.2574C14.1416 27.1287 14.2175 26.9537 14.2216 26.7698C14.2216 23.5398 16.826 20.9368 20.056 20.9368C21.1835 20.9368 22.2302 21.2582 23.121 21.8096C23.1999 21.8585 23.2876 21.8914 23.3793 21.9065C23.4709 21.9215 23.5646 21.9183 23.655 21.8971C23.7454 21.8758 23.8307 21.8369 23.906 21.7827C23.9814 21.7284 24.0453 21.6599 24.0941 21.5809C24.1429 21.5019 24.1757 21.4141 24.1905 21.3224C24.2053 21.2307 24.2018 21.137 24.1804 21.0467C24.1589 20.9563 24.1199 20.8711 24.0655 20.7959C24.011 20.7206 23.9423 20.6569 23.8632 20.6083C23.4618 20.3599 23.026 20.1654 22.5767 19.9981C23.6836 19.1845 24.4088 17.8787 24.4088 16.4067C24.4088 13.9497 22.3976 11.9385 19.9406 11.9385ZM19.9406 13.3472C21.637 13.3472 23.0014 14.7103 23.0014 16.4067C23.0014 18.1031 21.637 19.4607 19.9406 19.4607C18.2442 19.4607 16.8866 18.1031 16.8866 16.4067C16.8866 14.7103 18.2442 13.3472 19.9406 13.3472ZM27.0628 21.7931C26.9485 21.7964 26.8366 21.8275 26.737 21.8837C26.6373 21.94 26.5529 22.0198 26.4911 22.116L24.0652 25.7514L22.5437 24.7329C22.4666 24.6811 22.38 24.6449 22.2888 24.6266C22.1977 24.6083 22.1038 24.6081 22.0126 24.6261C21.9214 24.6441 21.8346 24.68 21.7573 24.7316C21.68 24.7832 21.6136 24.8496 21.562 24.9269C21.5103 25.0042 21.4745 25.0909 21.4564 25.1821C21.4384 25.2733 21.4385 25.3672 21.4568 25.4584C21.4751 25.5495 21.5112 25.6362 21.5631 25.7133C21.6149 25.7905 21.6815 25.8567 21.7589 25.9081L23.8742 27.3155C23.9512 27.3666 24.0376 27.4021 24.1284 27.4198C24.2191 27.4375 24.3125 27.4371 24.4031 27.4187C24.4937 27.4004 24.5798 27.3643 24.6565 27.3126C24.7332 27.261 24.799 27.1947 24.85 27.1176L27.6662 22.894C27.7397 22.7867 27.7819 22.6612 27.7884 22.5313C27.7948 22.4014 27.7651 22.2723 27.7026 22.1582C27.6401 22.0442 27.5472 21.9497 27.4343 21.8853C27.3214 21.8208 27.1928 21.7889 27.0628 21.7931Z",
    fill: "#1C74D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_829_2520",
    x: 0.618896,
    y: 0.619141,
    width: 38.762,
    height: 38.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_829_2520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_829_2520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_2520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8889,
    height: 16.8889,
    fill: "white",
    transform: "translate(11.8572 11.2539)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOpen);
export default __webpack_public_path__ + "static/media/account-open.fd7f7343656f41fb64b0641b1678b68a.svg";
export { ForwardRef as ReactComponent };